import { render, staticRenderFns } from "./TableForm12.vue?vue&type=template&id=147b7440&scoped=true"
import script from "./TableForm12.vue?vue&type=script&lang=ts"
export * from "./TableForm12.vue?vue&type=script&lang=ts"
import style0 from "./TableForm12.vue?vue&type=style&index=0&id=147b7440&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b7440",
  null
  
)

export default component.exports